import { Stack, Typography, useMediaQuery } from "@mui/material";
import { theme } from "../styles/mui-theme";

export const TitleAtom = ({ titleWhite, titlePink }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack
      spacing={0}
      maxWidth={isMobile ? "350px" : "550px"}
      width={"100%"}
      alignItems={isMobile && "center"}
      alignSelf={isMobile && "center"}
      sx={{ zIndex: 6 }}
    >
      <Typography
        variant="h1"
        textAlign={isMobile ? "center" : "start"}
        sx={{ userSelect: "none" }}
      >
        {titleWhite}
      </Typography>
      <Typography
        variant="h2"
        textAlign={isMobile ? "center" : "start"}
        sx={{ userSelect: "none" }}
      >
        {titlePink}
      </Typography>
    </Stack>
  );
};
